<template>
  <div class="collectionHeader clearfix f_16 color_40">
    <div class="headerItem fl bg_fff clearfix">
      <div data-growing-container data-growing-idx="100" class="item fl cursor_p pr"  @click="$router.push({path:'/talent/delivery'})" :class="[pathName ==='talentDelivery'?'item_bg_blue':'']">
        <span :class="[pathName ==='talentDelivery'?'item_bg_blue_font':'']">投递简历</span>
        <span :class="[pathName ==='talentDelivery'?'item_bg_blue_font_count':'tipsCount-blue']" class="tipsCount f_14 color_9c">({{cvCount}})</span>
        <!-- <span class="tips pa bg_current" v-if="messageCount.unviewed_job_deliveries_count>0"></span> -->
      </div>
      <div data-growing-container data-growing-idx="200" class="item fl cursor_p pr" @click="$router.push({path:'/talent/message'})" :class="[pathName ==='talentMessage'?'item_bg_blue':'']">
        <span :class="[pathName ==='talentMessage'?'item_bg_blue_font':'']">邀约记录</span>
        <span :class="[pathName ==='talentMessage'?'item_bg_blue_font_count':'tipsCount-blue']" class="tipsCount f_14 color_9c" v-if="(messageCount.application_passed_count + messageCount.application_other_count)>0">({{messageCount.application_passed_count + messageCount.application_other_count}})</span>
      </div>
      <div data-growing-container data-growing-idx="300" class="item fl cursor_p pr" @click="$router.push({path:'/talent/collection'})" :class="[pathName ==='talentCollection'?'item_bg_blue':'']">
        <span :class="[pathName ==='talentCollection'?'item_bg_blue_font':'']">储备人才</span>
        <span :class="[pathName ==='talentCollection'?'item_bg_blue_font_count':'tipsCount-blue']" class="tipsCount f_14 color_9c" v-if="messageCount.favorite_count>0">({{messageCount.favorite_count}})</span>
      </div>
    </div>
    <div data-growing-container data-growing-idx="400" class="headerItem fl bg_fff clearfix new-container">
      <div class="item fl cursor_p pr" @click="$router.push({path:'/talent/refuseDelivery'})" :class="[pathName ==='talentRefuseDelivery'?'item_bg_blue':'']">
        <span :class="[pathName ==='talentRefuseDelivery'?'item_bg_blue_font':'']">不合适</span>
        <span  :class="[pathName ==='talentRefuseDelivery'?'item_bg_blue_font_count':'tipsCount-blue']"  class="tipsCount f_14 color_9c" v-if="messageCount.unsuited_job_deliveries_count>0">({{messageCount.unsuited_job_deliveries_count}})</span>
      </div>
    </div>

    <div class="download-all flex" v-if="pathName ==='talentDelivery'">
      <div class="choose-container flex cursor_p" @click="allCheck">
        <span class="iconfont iconxuanzhong" v-if="allChecked" />
        <span class="iconfont iconweixuanzhong" v-else />
        <span class="font">全选</span>
      </div>
      <div class="download-btn flex cursor_p" @click="downloadAll">
        <span class="iconfont iconxiazai1" />
        <span class="font">批量下载</span>
      </div>
    </div>

    <!-- <div class="toTopJob fr" v-if="toTopJobVisible" @click="$emit('toTopJobCallback')">
      <span>🔥</span><span>【精准曝光】功能上线！快速获得更多人才投递</span>
    </div> -->

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// 所有接口
import actions from '@/actions/index'

import {checkUserState, get_tUser , toLogin} from '@/utils/utils';

export default {
  name: 'collectionTabBar',
  data(){
    return {
      userJWT:{},
    }
  },
  props: {
    pathName: {
      type: String,
      default: ''
    },
    toTopJobVisible: {
      type: Boolean,
      default: false
    },
    allChecked: {
      type: Boolean,
      default: false
    }
    // cvCount: {
    //   type: Number,
    //   default: 0
    // }
  },
  computed:{
    ...mapState('delivery',['unviewed_job_deliveries_count','cvCount']),
    ...mapState('message',['messageCount']),
  },
  async created(){
    this.userJWT = await get_tUser();
    if(this.userJWT.h_t){
      // 获取投递未读数
      this.getUnviewedCount();
    }

  },
  methods:{
    ...mapMutations('delivery',['updateUnviewedJobDeliveriesCount']),
    downloadAll() {
      this.$emit('downloadAll');
    },
    allCheck() {
      this.$emit('allCheck')
    },
    // 获取投递未读数
    getUnviewedCount(){
      actions.job_deliveries.get_unviewed_count().then(res=>{
        if(res.code === 1000){
          let { unviewed_job_deliveries_count } = res.data;
          this.updateUnviewedJobDeliveriesCount(unviewed_job_deliveries_count);
        }
      })
    },

  },
}
</script>
<style lang="scss" scoped>

//顶部导航
.collectionHeader{
  margin-bottom: 16px;
  position: relative;
  .headerItem{
    height: 48px;
    line-height: 48px;
    border-radius: 6px;
    margin-right: 32px;
    box-shadow: 0px 8px 15px 0px rgba(149, 156, 182, 0.15);
    .item{
      padding: 0 24px;
      margin-right: 1px;
      &:hover{
        color: #4183FF;
        .tipsCount-blue {
          color: #4183FF;
        }
      }
      &::before{
        display: block;
        content: '';
        width: 1px;
        height: 14px;
        position: absolute;
        top: 17px;
        right: -1px;
        background: #D9D9D9;
      }
      &:last-child{
        margin-right: 0;
        &::before{
          display: none;
        }
      }
      .tipsCount{
        margin-left: 8px;
        // color: #9c9c9c;
      }
      .tips{
        width: 7px;
        height: 7px;
        border-radius: 4px;
        left: 80px;
        top: 12px;
      }
    }
    .item_bg_blue {
      background-color: #4183FF;
      border-radius: 6px;
      .item_bg_blue_font {
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 500;
      }
      .item_bg_blue_font_count {
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 500;
      }
      .item_bg_blue_font_count:hover {
        color: #FFFFFF !important;
        .tipsCount {
          color: #FFFFFF !important;
        }
      }
    }
  }

  .toTopJob {
    cursor: pointer;
    height: 48px;
    display: flex;
    align-items: center;
    color: #4183FF;
    font-size: 14px;
    >i {
      font-size: 16px;
      margin-right: 9px;
    }
  }

  .download-all {
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    .choose-container {
      .iconfont {
        font-size: 18px;
        color: #CFCFCF;
      }
      .iconxuanzhong {
        color: #4183FF;
      }
      .font {
        font-size: 14px;
        color: #404040;
        margin-left: 6px;
        line-height: 18px;
      }
    }
    .download-btn {
      width: 100px;
      height: 32px;
      margin-left: 16px;
      background: #679CFF;
      border-radius: 6px;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #FFFFFF;
      &:hover {
        opacity: .8;
      }
      .font {
        margin-left: 5px;
      }
    }
  }
}

</style>
